import { ReactElement } from 'react';

import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import { Text } from '@dreryk/react-components';

import { translationKeys } from '../../translations';
import { MedicineDetailsModalOpenAction } from '../MedicineDetailsModal/MedicineDetailsModalOpenAction';
import { MedicineActiveIngredients } from '../MedicineActiveIngredients';
import { MedicineName } from '../MedicineName';
import { MedicineOutdatedNotification } from '../MedicineOutdatedNotification/MedicineOutdatedNotification';

type MedicineFullNameReadOnlyCellProps = {
   readonly medicine: MedicineSimple;
   readonly reimbursementCode?: string;
};

export const MedicineFullNameReadOnlyCell = (props: MedicineFullNameReadOnlyCellProps): ReactElement => {
   const valid = props.medicine.valid !== false;

   return (
      <div>
         {valid ? null : <MedicineOutdatedNotification />}
         <MedicineDetailsModalOpenAction
            confirmationButtonLabel={translationKeys.medicine.details.addToPrescription}
            medicine={props.medicine}
            render={(openModal) => (
               <MedicineName
                  name={props.medicine.fullName}
                  atc={props.medicine.atc}
                  onClick={openModal}
                  valid={valid}
               />
            )}
         />
         <MedicineActiveIngredients activeIngredients={props.medicine.activeIngredients} valid={valid} />
         {valid && props.reimbursementCode ? <Text testId={'reimbursementCode'}>{props.reimbursementCode}</Text> : null}
      </div>
   );
};
